// javascript goes here
console.log('smack it, smack it in the air!');
